import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

function Main() {
    return(
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Research"/>
            <section className="project-detail">
                <div className='container'>
                    <div className="c-heading">  
                        <h1>Incubation and Entrepreneurship</h1>
                    </div> 
                    <div className="border">
                            <div className='mt-3 ms-3'>
                                <h4 className='mb-3'>Research Equipment Utilisation </h4>
                                <ul className='myulcustarrow'>
                                    <li> <Link className='c-link' to= "https://files.iittp.ac.in/pdfs/csrc/Business Incubation Policy.pdf" target="_blank"> Innovation and Business Incubation - Guidelines and Policy</Link> </li>
                                </ul>
                            </div>
                    </div> 
                </div>
            </section>
        </>
    );
}

export default Main;